<template>
	<div class="content-wrapper">
		<!-- Content -->
		<div class="container flex-grow-1 container-p-y">
			<div class="row g-6 mb-6">
				<!-- Congratulations card -->
				<div class="col-md-8 col-xxl-8">
					<div class="card">
						<div class="d-flex align-items-end row">
							<div class="col-md-6 order-2 order-md-1">
								<div class="card-body">
									<h4 class="card-title mb-4" v-if="profile">
										Bonjour <span class="fw-bold">{{ profile.firstName }}!</span>
									</h4>
									<p class="mb-0">Nous sommes ravis de vous accueillir sur notre plateforme dédiée à la formation et au développement professionnel dans l'univers de l'aviation.</p>
									<br/>
									<router-link to="/trainings/create" class="btn btn-primary">
										Découvrir nos formations
									</router-link>
								</div>
							</div>
							<div class="col-md-6 text-center text-md-end order-1 order-md-2">
								<div class="card-body pb-0 px-0 pt-2">
									<img
										src="@/assets/img/illustrations/illustration-john-light.png"
										height="186"
										class="scaleX-n1-rtl"
										alt="View Profile"
										data-app-light-img="illustrations/illustration-john-light.png"
										data-app-dark-img="illustrations/illustration-john-dark.png" />
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- Congratulations card -->
				<div class="col-xxl-4" v-if="company">
					<div class="card h-100">
						<div class="card-body text-nowrap">
							<h5 class="card-title mb-1">Crédits</h5>
							<p class="card-subtitle mb-3">Votre nombre de crédits</p>
							<h4 class="text-primary mb-0">{{ company.credits }}</h4>
							<p class="mb-3"></p>
						</div>
					<img
						src="@/assets/img/illustrations/trophy.png"
						class="position-absolute bottom-0 end-0 me-4"
						height="140"
						alt="view sales" />
					</div>
				</div>
				
				<!--/ Total Sales chart -->
			</div>
		</div>
		<!-- / Content -->

		<div class="content-backdrop fade"></div>
	</div>
</template>

<script>
import HTTP from "@/axios";

export default {
	name: "DashboardPage",

	data() {
		return {
			profile: null,
			company: null
		}
	},

	async mounted() {
		this.fetchProfile();
		this.fetchCompany();
	},


	methods: {
		async fetchCompany() {
			try {
				const response = await HTTP(`/company`);
				this.company = response.data.company;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},
		async fetchProfile() {
			try {
				const response = await HTTP(`/user/profile`);
				this.profile = response.data.profile;
			} catch (error) {
				// Récupérer le message d'erreur de l'API ou définir un message par défaut
				const errorMessage = error?.response?.data?.message || "Une erreur est survenue, merci de contacter contact@pika-aero.com";

				alert(errorMessage);

				// Log détaillé dans la console (utile en développement)
				console.error("Erreur API:", error);
			}
		},
	}
};
</script>

<style scoped>
/* Ajoutez des styles spécifiques à la page Dashboard */
.dashboard {
	padding: 1rem;
}

.card-title {
	font-size: 1.2rem;
}

.card-text {
	margin: 0;
}
</style>
